import {normalize} from 'normalizr';

import api from '../../api';
import {schema} from '../../schema';
import {addEntities} from '../../actions';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const USER_PROFILE_LIST_REQUEST = 'USER_PROFILE_LIST_REQUEST';
export const USER_PROFILE_LIST_SUCCESS = 'USER_PROFILE_LIST_SUCCESS';
export const USER_PROFILE_LIST_FAILURE = 'USER_PROFILE_LIST_FAILURE';

// ACTION CREATORS

export function userProfileListRequest(page, limit, order, filter) {
  Logger.log('debug', `[userProfiles.actions] userProfileListRequest(${page}, ${limit}, ${order}, %j)`, filter);
  return {
    type: USER_PROFILE_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter
  }
}

export function userProfileListSuccess(data) {
  Logger.log('debug', `[userProfiles.actions] userProfileListSuccess(%j)`, data);
  return {
    type: USER_PROFILE_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now()
  }
}

export function userProfileListFailure(error) {
  Logger.log('debug', `[userProfiles.actions] userProfileListFailure(%j)`, error);
  return {
    type: USER_PROFILE_LIST_FAILURE,
    error: error
  }
}


// API THUNK ACTION CREATORS

export function loadUserProfiles(page=1, limit=10, order=null, filter=null, cb=function(){}) {
  Logger.log('debug', `[userProfile.actions] loadUserProfiles(${page}, ${limit}, ${order}, %j, ###)`, filter);

  return async function(dispatch) {
    dispatch(userProfileListRequest(page, limit, order, filter));

    // call API
    const response = await api.getUserProfiles(page, limit, order, filter);
    let success = false;

    // get user profiles list success
    if (200 === response.get('status')) {

      Logger.log('info', `Get API user profiles list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`);

      const normalizedEntities = normalize(response.getIn(['data', 'user_profiles']), [schema.userProfile]);
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(userProfileListSuccess(data));
      success = true;

    } else if (1 === page && 204 === response.get('status')) {

      Logger.log('info', `Get API user profiles success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`);
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: []
      };
      dispatch(userProfileListSuccess(data));
      success = true;
      
    // get user profiles list failure
    } else {
      Logger.log('info', `Get API user profiles list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`);
      dispatch(userProfileListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  }
}

Logger.log('silly', `userProfiles.actions loaded.`);
